namespace $.$$ {

	$mol_style_define( $shm_date_calendar, {
		Day_button: {
			'@': {
				shm_date_selected: {
					true: {
						color: $mol_theme.current,
					},
				},

				disabled: {
					true: {
						opacity: .35,
						color: $mol_theme.shade,
					},
				},
			},
		},
	} )

}
